var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrush2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.63477,
    y: 3.9043,
    width: 6.73077,
    height: 8.07692,
    rx: 0.482655,
    stroke: "#FF0000",
    strokeWidth: 0.579186
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.625,
    y: 2.55762,
    width: 8.75,
    height: 1.34615,
    rx: 0.241327,
    stroke: "#FF0000",
    strokeWidth: 0.579186,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6543 2.01953L8.3466 2.01953",
    stroke: "#FF0000",
    strokeWidth: 0.579186,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.6543V10.3658",
    stroke: "#FF0000",
    strokeWidth: 0.579186,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68262 5.6543V10.3658",
    stroke: "#FF0000",
    strokeWidth: 0.579186,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31738 5.6543V10.3658",
    stroke: "#FF0000",
    strokeWidth: 0.579186,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrush2);
export default __webpack_public_path__ + "static/media/trush-2.c1bfc0d0e52f07e6bf9ab3e5ae84f02c.svg";
export { ForwardRef as ReactComponent };